(function () {
  'use strict';

  var ATTR = 'data-home-banner-swiper';
  var instances = new WeakMap();

  function syncDots(swiper, dots) {
    var idx = swiper.realIndex !== undefined ? swiper.realIndex : swiper.activeIndex;
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === idx);
    });
  }

  function init(root) {
    if (!root || instances.has(root) || typeof Swiper === 'undefined') return;

    var slideCount = root.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    var section = root.closest('.home-banner');
    var dots = section ? section.querySelectorAll('.prd-carousel__dot') : [];
    var prevEl = section ? section.querySelector('.prd-carousel__arrow--prev') : null;
    var nextEl = section ? section.querySelector('.prd-carousel__arrow--next') : null;
    var options = {
      loop: slideCount > 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 800,
    };

    if (slideCount > 1) {
      options.autoplay = {
        delay: 5000,
        disableOnInteraction: false,
      };
    }

    if (prevEl && nextEl) {
      options.navigation = {
        prevEl: prevEl,
        nextEl: nextEl,
      };
    }

    var swiper = new Swiper(root, options);

    if (slideCount > 1 && dots.length) {
      syncDots(swiper, dots);

      swiper.on('slideChange', function () {
        syncDots(swiper, dots);
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.dataset.idx, 10);
          if (slideCount > 1 && swiper.params.loop) {
            swiper.slideToLoop(idx);
          } else {
            swiper.slideTo(idx);
          }
        });
      });
    }

    instances.set(root, swiper);
  }

  function destroyIn(container) {
    (container || document).querySelectorAll('[' + ATTR + ']').forEach(function (root) {
      var swiper = instances.get(root);
      if (!swiper) return;
      swiper.destroy(true, true);
      instances.delete(root);
    });
  }

  function initAll(container) {
    (container || document).querySelectorAll('[' + ATTR + ']').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event && event.target) destroyIn(event.target);
  });
})();
